module.exports = __webpack_public_path__ + "static/img/day5.2560f7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour6/day5.jpg
// module id = JD4R
// module chunks = 0